import { render } from "./reasons.vue?vue&type=template&id=135dd1e9&scoped=true"
import script from "./reasons.vue?vue&type=script&lang=js"
export * from "./reasons.vue?vue&type=script&lang=js"

import "./reasons.vue?vue&type=style&index=0&id=135dd1e9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-135dd1e9"

export default script